import { render, staticRenderFns } from "./TabOpener.vue?vue&type=template&id=36e23f73&scoped=true&"
import script from "./TabOpener.vue?vue&type=script&lang=js&"
export * from "./TabOpener.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e23f73",
  null
  
)

export default component.exports